;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"0d340493bc6f4b74d620f681f070eed17f193e04"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.2.12";globalThis["_sentryRewriteFramesDistDir"] = ".next-cli-build";globalThis["_sentryVercelCronsConfig"] = undefined;import * as Sentry from "@sentry/nextjs";

export async function register() {
  if (process.env.NEXT_RUNTIME === "nodejs") {
    await import("../sentry.server.config");
  }

  if (process.env.NEXT_RUNTIME === "edge") {
    await import("../sentry.edge.config");
  }
}

export const onRequestError = Sentry.captureRequestError;
